import React, { memo } from 'react';
import styled from 'styles/styled-components';
import ResultRowMobile from '../ResultRow/ResultRowMobile';
import { ResultTableProps } from './types';

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ResultTableMobile = ({
  products,
  quantities,
  onToggleRow,
  onQuantityChange,
  onChangeProduct,
  onSwapProduct,
  loggedIn,
  goToSignIn,
}: ResultTableProps) => (
  <List>
    {products.map((product) => (
      <ResultRowMobile
        key={product.id}
        product={product}
        quantity={quantities[product.id] ?? product.defaultQuantity}
        onToggle={onToggleRow}
        onQuantityChange={onQuantityChange}
        onChangeProduct={onChangeProduct}
        onSwapProduct={onSwapProduct}
        loggedIn={loggedIn}
        goToSignIn={goToSignIn}
      />
    ))}
  </List>
);

export default memo(ResultTableMobile);
